import { VIEW_SETTINGS_IGNORED_IN_BUBBLE_CHART_VIEW_MODEL_SOURCE } from '@ardoq/bubble-chart';
import { ViewIds } from '@ardoq/api-types';
import { map, Observable } from 'rxjs';
import {
  ViewpointModeInstanceViewSettings,
  WorkspaceModeInstanceViewSettings,
} from 'views/environmentals/viewSettings/types';
import { getFilteredViewSettings$ } from 'views/filteredViewSettings$';

export const getViewSettingsForModelSourceData$ = (
  viewSettingsWithChanges$: Observable<
    | ViewpointModeInstanceViewSettings<ViewIds.BUBBLE>
    | WorkspaceModeInstanceViewSettings<ViewIds.BUBBLE>
  >
) =>
  getFilteredViewSettings$(
    viewSettingsWithChanges$,
    VIEW_SETTINGS_IGNORED_IN_BUBBLE_CHART_VIEW_MODEL_SOURCE
  ).pipe(map(({ currentSettings }) => currentSettings));

export const getViewSettingsForRenderingData$ = (
  viewSettingsWithChanges$: Observable<
    | ViewpointModeInstanceViewSettings<ViewIds.BUBBLE>
    | WorkspaceModeInstanceViewSettings<ViewIds.BUBBLE>
  >
) =>
  viewSettingsWithChanges$.pipe(map(({ currentSettings }) => currentSettings));
